import { Center, ErrorText, FileViewer, LoadingIndicator } from "@/components";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

import { useGetCompanyFile } from "@/hooks/queries/useGetCompanyFile";

const CompanyAttachmentViewer = ({
  companyFileId,
}: {
  companyFileId: number;
}) => {
  const {
    data: companyFile,
    isPending: isCompanyFilePending,
    isError: isCompanyFileError,
  } = useGetCompanyFile({
    enabled: true,
    companyFileId,
  });

  const render = () => {
    if (isCompanyFilePending) {
      return <LoadingIndicator className="absolute inset-0" variant="medium" />;
    }
    if (isCompanyFileError) {
      return (
        <Center className="absolute inset-0">
          <ErrorText errorMessage="An error occurred while loading file. Please try again." />
        </Center>
      );
    }

    return (
      <FileViewer mimeType={companyFile.mimeType} url={companyFile.signedUrl} />
    );
  };

  return render();
};

export const CompanyAttachmentViewerDialog = ({
  companyFileId,
  mimeType,
  onOpenChange,
  open,
}: {
  companyFileId?: number;
  mimeType?: string;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) => {
  const isImage = mimeType?.startsWith("image/");

  const render = () => (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        className={cn(
          "max-h-[92vh] max-w-4xl overflow-y-scroll",
          isImage && "w-fit",
        )}
      >
        {/* This ensures spacing between top of dialog and content. */}
        <DialogHeader />
        {/* The dialog should only be open when `companyFileId` is present. */}
        {companyFileId && (
          <CompanyAttachmentViewer companyFileId={companyFileId} />
        )}
      </DialogContent>
    </Dialog>
  );

  return render();
};
